import { Stack } from '@mui/material';
import { useAtom } from 'jotai';

import ContentNotification from '@/components/ContentNotfication';
import AIAnalyst from '@/features/AdminAIAnalyst';
import AIResponseActionMatrix from '@/features/AIResponseActionMatrix';
import {
  selectedOrganizationAtom,
  selectedOrganizationIdAtom
} from '@/pages/Organizations';

import { useFetchSettings, useMutationSettings } from '../Administration.store';
import type { AIResponseActionSettingsPayload } from '../Administration.types';

const AdministrationAISettings = () => {
  const [selectedOrganizationId] = useAtom(selectedOrganizationIdAtom);
  const [selectedOrganization] = useAtom(selectedOrganizationAtom);
  const {
    refetch,
    isError: isSettingsError,
    serverData: orgInfo
  } = useFetchSettings();
  const mutation = useMutationSettings(refetch, selectedOrganization?.label);

  const handleSave = async (
    updatedOrgInfo: AIResponseActionSettingsPayload
  ) => {
    await mutation.mutateAsync(updatedOrgInfo);
  };

  return (
    <>
      {selectedOrganizationId === 0 && (
        <ContentNotification
          title="Select an organization"
          text="Please select an organization to view and edit its settings."
        />
      )}
      {selectedOrganizationId !== 0 && (
        <Stack spacing={2}>
          <AIAnalyst orgLabel={selectedOrganization?.label ?? ''} />
          <AIResponseActionMatrix
            handleSave={handleSave}
            isSaving={mutation.isPending}
            isSettingsError={isSettingsError}
            orgInfo={orgInfo}
            organizationLabel={selectedOrganization?.label ?? ''}
            retrySettings={() => {
              void refetch();
            }}
          />
        </Stack>
      )}
    </>
  );
};

export default AdministrationAISettings;
